import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DashboardReducer } from "../Reducer/Dashboard/DashboardReducer";
import { DashboardType } from "../../dto/Dashboard.dto";


export interface DashboardState {
    loading: boolean;
    success: boolean;
    error: string | null;  
    dashboardData: DashboardType | null
  }

const initialState: DashboardState = {
    loading: false,
    success: false,
    error: null,
    dashboardData: null
  };
  
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
    reducers: {
        SetDashboardData(state, action: PayloadAction<DashboardType>) {
            state.dashboardData = action.payload;
      }
    },
    extraReducers: (builder) => {
        DashboardReducer(builder);
      },
    
});
export const {  SetDashboardData } = dashboardSlice.actions;
export default dashboardSlice.reducer;